import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {Button} from 'ui-library';
import i18n from 'i18n';
import {defaultAvatarImg} from 'assets/images';
import {Img} from 'apps/shared/components';

const uploadAvatar = createClass({

  propTypes: {
    image: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    loading: PropTypes.bool
  },

  getDefaultProps() {
    return {
      image: defaultAvatarImg
    };
  },

  handleChange(evt) {
    if (this.props.loading) return;
    if (this.props.onChange) this.props.onChange(evt);
  },

  render() {
    const {image, label, loading} = this.props;
    const defaultLabel = i18n.get('INF_SETTINGS_ACCOUNT_UPLOAD_BUTTON_LABEL');

    return (
      <div className='vf-upload-avatar'>
        <Img
          className='vf-upload-avatar-image image-cover vf-bg-gray-color'
          src={image}
          width={100}
          height={100}
        />

        <div className='vf-upload-avatar-upload'>
          {loading
            ?
              <Button
                disabled
                size='sm'
                style={{borderRadius: 0}}
              >
                {i18n.get('LOADING')}
              </Button>
            :
              <Button
                className='vf-bg-white-light-color vf-text-gray-dark'
                onClick={() => this.input.click()}
                size='sm'
                style={{borderRadius: 0}}
              >
                {label || defaultLabel}
              </Button>
          }

          <input
            type='file'
            accept='image/jpeg,image/bmp,image/png'
            className='vf-upload-avatar-input'
            onChange={this.handleChange}
            ref={ref => this.input = ref}
          />
        </div>
      </div>
    );
  }
});

module.exports = uploadAvatar;
